import { BoxProps, Stack } from "@mui/material";

import { VehicleVisualModelDto } from "@/core/api/generated/v1";
import { ResponsiveStyleValueCustom } from "@/theme/types";

import { VisualModelSvgViewer } from "./Viewer/v2/VisualModelSvgViewer";

interface Props {
  visualModel: VehicleVisualModelDto;
  imageProps?: {
    width?: ResponsiveStyleValueCustom<number | string>;
    height?: ResponsiveStyleValueCustom<number | string>;
  };
  sx?: BoxProps["sx"];
}

export function VehicleVisualModelImagesDisplay({ visualModel, imageProps, sx }: Props) {
  return (
    <>
      <Stack direction='row' sx={{ flexWrap: "wrap", gap: 1, ...sx }}>
        {visualModel.images?.map((image, i) => (
          <VisualModelSvgViewer
            key={i}
            visualModelId={visualModel.id}
            visualModel={visualModel}
            imageSelector={{
              image: image,
            }}
            points={[]}
            svgViewerProps={{
              svgProps: {
                width: imageProps?.width || 200,
                height: imageProps?.height || 200,
                minWidth: imageProps?.width || 200,
                minHeight: imageProps?.height || 200,
                maxWidth: imageProps?.width || 200,
                maxHeight: imageProps?.height || 200,
              },
              isZoomEnabled: false,
              isResizeEnabled: false,
              isPointDragEnabled: false,
            }}
            withVisualModelInfo={false}
          />
        ))}
      </Stack>
    </>
  );
}
